((Drupal, once) => {
  Drupal.behaviors.nvlPopupNotice = {
    attach(context) {
      const elements = once('nvlPopupNotice', '#nvl-popup-notice', context);

      elements.forEach((el) => {
        const overlay = el;
        const container = overlay.querySelector('.popup-notice__container');
        const closeBtn = overlay.querySelector('.popup-notice__close-button');
        const { contentHash, everyVisit } = overlay.dataset || {};
        const storageKey = 'nvl_popup_dismissed_hash';

        const isDismissed = () => {
          if (everyVisit) return false;
          try {
            return localStorage.getItem(storageKey) === String(contentHash);
          } catch (e) {
            return false;
          }
        };

        // Skip entirely if this version was already dismissed.
        if (isDismissed()) {
          overlay.remove();
          return;
        }

        let previousFocus;
        let wasScrollLocked;
        let closeTimer;
        let isOpen = false;

        const showPopup = () => {
          if (isOpen || isDismissed()) return;
          clearTimeout(closeTimer);
          previousFocus = document.activeElement;
          wasScrollLocked = document.body.classList.contains('overflow-hidden');
          isOpen = true;
          overlay.classList.remove('popup-notice--closing');
          overlay.classList.add('popup-notice--active');
          overlay.removeAttribute('aria-hidden');
          document.body.classList.add('overflow-hidden');
          closeBtn.focus({ preventScroll: true });
        };

        const closePopup = () => {
          if (!isOpen) return;
          isOpen = false;
          overlay.classList.add('popup-notice--closing');
          overlay.classList.remove('popup-notice--active');
          if (!wasScrollLocked)
            document.body.classList.remove('overflow-hidden');
          if (overlay.contains(document.activeElement))
            document.activeElement.blur();
          previousFocus?.focus({ preventScroll: true });
          overlay.setAttribute('aria-hidden', 'true');

          if (!everyVisit) {
            try {
              localStorage.setItem(storageKey, contentHash);
            } catch (e) {
              // Storage unavailable; the notice will simply reopen next visit.
            }
          }

          // Keep the hidden element for Back/Forward cache restoration.
          closeTimer = setTimeout(() => {
            overlay.classList.remove('popup-notice--closing');
          }, 400);
        };

        closeBtn.addEventListener('click', closePopup);
        overlay.addEventListener('click', (event) => {
          if (!container.contains(event.target)) closePopup();
        });

        document.addEventListener('keydown', (event) => {
          if (!isOpen) return;
          if (event.key === 'Escape') {
            event.preventDefault();
            closePopup();
          } else if (event.key === 'Tab') {
            const focusable = Array.from(
              container.querySelectorAll(
                'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]',
              ),
            ).filter((element) => element.getClientRects().length);
            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            if (event.shiftKey && document.activeElement === first) {
              event.preventDefault();
              last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
              event.preventDefault();
              first.focus();
            }
          }
        });

        document.addEventListener('focusin', (event) => {
          if (isOpen && !overlay.contains(event.target)) closeBtn.focus();
        });

        const openTimer = setTimeout(showPopup, 300);
        window.addEventListener('pagehide', () => {
          clearTimeout(openTimer);
          closePopup();
        });
        window.addEventListener('pageshow', (event) => {
          if (event.persisted) showPopup();
        });
      });
    },
  };
})(Drupal, once);
